import { UMButton, UMR, UMStack } from '../_components';
import { CalcButton } from './CalcButton';
import type { useDensity } from './useDensity';

export function DensityControls({ density: d, blocked }: { density: ReturnType<typeof useDensity>; blocked: boolean }) {
  return <UMStack>
    <CalcButton disabled={blocked || d.loading || !d.canCalculate} onClick={d.calculate}>Calculer densité linéaire</CalcButton>
    <div role="status" aria-live="polite" style={{ fontSize: 12, color: UMR.textMuted }}>
      {!d.canCalculate && <div>La sélection doit contenir au moins une centrale de production, des canalisations et au moins un bâtiment raccordé pour pouvoir calculer la densité linéaire du réseau</div>}
      {d.loading && <div>Calcul simulé en cours…</div>}
      {d.error && <div role="alert">{d.error}</div>}
      {d.result && !d.loading && <div aria-label="Résultat de densité linéaire">
        Densité moyenne simulée : {d.result.value.toLocaleString('fr-FR', { maximumFractionDigits: 2 })} MWhu/m
        {d.stale && ' (à recalculer)'}
      </div>}
    </div>
    {d.loading && <UMButton variant="secondary" onClick={d.cancel}>Annuler le calcul de densité</UMButton>}
  </UMStack>;
}
